<template>
    <div class="ChatCQU_sci">
        <comHeader :active="active" :value="value"></comHeader>
        <div class="box">
            <p class="chat_s">
                <span class="slogan_">{{ organ_name }}{{ $t('chatfellows.introduceOne') }}</span>
            </p>
            <div class="main_body">
                <div class="main_left">
                    <h2>{{ $t('chatfellows.enter') }}</h2>
                    <el-input type="textarea" :rows="5" :placeholder="$t('chatresearch.searchTip')" v-model="textarea">
                    </el-input>
                    <el-button class="submit_css" :disabled="Anti_shake" size="small" type="warning"
                        @click="search()">{{ $t('chatfellows.submit') }}</el-button>
                    <div class="sift_s">
                        <div class="sift_box">
                            <!-- <h3>{{ $t('chatfellows.year') }}</h3> -->
                            <div class="sift_tit">
                                <div class="tit">{{ $t('chatfellows.year') }}</div>
                                <div class="sub" @click="sift_all">{{ $t('public.select') }}</div>
                            </div>
                            <div class="sift_list" v-loading="loading" :element-loading-text="$t('public.load')"
                                element-loading-spinner="el-icon-loading">
                                <el-checkbox-group v-model="cqu.year">
                                    <el-checkbox :label="item.key" v-for="(item, index) in year_s" :key="index">
                                        <span class="tooltip_span"
                                            :title="item.key + `\xa0\xa0\xa0(\xa0` + item.doc_count + `\xa0)`">
                                            {{ item.key }}</span>
                                    </el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </div>
                        <div class="sift_box">
                            <div class="sift_tit">
                                <div class="tit">{{ $t('public.subject') }}</div>
                                <div class="sub" @click="sift_all">{{ $t('public.select') }}</div>
                            </div>
                            <div class="sift_list" v-loading="loading" :element-loading-text="$t('public.load')"
                                element-loading-spinner="el-icon-loading">
                                <el-checkbox-group v-model="cqu.category">
                                    <el-checkbox :label="item.key" v-for="(item, index) in subject_s" :key="index">
                                        <span class="tooltip_span"
                                            :title="item.key + `\xa0\xa0\xa0(\xa0` + item.doc_count + `\xa0)`">
                                            {{item.key }}</span>
                                    </el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </div>
                        <div class="sift_box">
                            <div class="sift_tit">
                                <div class="tit">{{ $t('public.author') }}</div>
                                <div class="sub" @click="sift_all">{{ $t('public.select') }}</div>
                            </div>
                            <div class="sift_list" v-loading="loading" :element-loading-text="$t('public.load')"
                                element-loading-spinner="el-icon-loading">
                                <el-checkbox-group v-model="cqu.author">
                                    <el-checkbox :label="item.key" v-for="(item, index) in author_s" :key="index">
                                        <span class="tooltip_span"
                                            :title="item.key + `\xa0\xa0\xa0(\xa0` + item.doc_count + `\xa0)`">
                                            {{item.key }}</span>
                                    </el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="main_right" v-loading="loading" :element-loading-text="$t('public.load')"
                    element-loading-spinner="el-icon-loading">
                    <div class="data_list">
                        <div class="data_txt" v-for="(item, index) in list_data" :key="index">
                            <div class="txt_top">
                                <div class="txt_s">
                                    <h3 v-if="item._source.title">{{ item._source.title }}</h3>
                                    <h3 v-else>{{ item._source.ch_title }}</h3>
                                    <p v-if="item._source.author && item._source.author.length > 0">
                                        <span style="font-weight: 600; font-size: 16px">{{ $t('public.author') }}:
                                        </span>
                                        <span v-for="(item_aut, index_) in item._source.author" :key="index_">
                                            {{ item_aut }}
                                            <span v-if="index_ + 1 < item._source.author.length">;</span>
                                        </span>
                                    </p>
                                    <p v-if="item._source.keyword && item._source.keyword.length > 0">
                                        <span style="font-weight: 600; font-size: 16px">{{ $t('public.keywords') }}:
                                        </span>
                                        <span v-for="(item_word, index__) in item._source.keyword" :key="index__">
                                            {{ item_word }}
                                            <span v-if="index__ + 1 < item._source.keyword.length">;</span>
                                        </span>
                                    </p>
                                    <p>
                                        <span style="margin: 0 0 0 0px" v-if="item._source.year">
                                            <span style="font-weight: 600; font-size: 16px">
                                                {{ $t('chatfellows.year') }}:
                                            </span>
                                            {{ item._source.year }}
                                        </span>
                                        <span style="margin: 0 0 0 30px" v-if="item._source.doi">
                                            <span style="font-weight: 600; font-size: 16px">DOI:
                                            </span>
                                            <span class="doi_css" @click="doi_url(item._source.doi)">{{ item._source.doi
                                                }} <i class="el-icon-top-right"></i></span>
                                        </span>
                                    </p>
                                </div>
                                <div class="img_s" @click="search_img(item._source.abstract, item._source.ch_abstract)">
                                    <img src="../../assets/img/CQU_img.png" alt="" />
                                    <div class="img_txt">{{ $t('chatfellows.relatedLiterature') }}</div>
                                </div>
                            </div>
                            <!-- 英文摘要 -->
                            <div class="abstract_css" v-if="item._source.abstract">
                                <span style="font-weight: 600; font-size: 16px">{{ $t('chatfellows.enSummary') }}:
                                </span>
                                <span v-if="item._source.abstract_show">{{ item._source.abstract }}
                                    <span class="view_all" style="" @click="show_all(index)">{{ $t('public.close')
                                        }}</span></span>
                                <span v-else>
                                    <span v-if="item._source.abstract.length < 240">{{
            item._source.abstract
        }}</span>
                                    <span v-else>{{ item._source.abstract.slice(0, 240) }} <span>...</span><span
                                            class="view_all" style="" @click="show_all(index)">{{ $t('public.all')
                                            }}</span></span>
                                </span>
                            </div>
                            <!-- 中文摘要 -->
                            <div v-else>
                                <div class="abstract_css" v-if="item._source.ch_abstract">
                                    <span style="font-weight: 600; font-size: 16px">{{ $t('chatfellows.cnSummary') }}:
                                    </span>
                                    <span v-if="item._source.abstract_show_ch">{{ item._source.ch_abstract }}
                                        <span class="view_all" style="" @click="show_all_ch(index)">
                                            {{ $t('public.close') }}
                                        </span>
                                    </span>
                                    <span v-else>
                                        <span v-if="item._source.ch_abstract.length < 240">
                                            {{ item._source.ch_abstract }}
                                        </span>
                                        <span v-else>{{ item._source.ch_abstract.slice(0, 240) }}
                                            <span>...</span><span class="view_all" style=""
                                                @click="show_all_ch(index)">{{ $t('public.all') }}</span></span>
                                    </span>
                                </div>
                            </div>

                            <div class="list_bottom">
                                <span class="fraction_">{{ item._score }}</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="total > cqu.size" class="pag_s">
                        <span style="display: inline-block;    padding: 37px 0px 0px;">
                            {{ total }} {{ $t('public.item') }}
                        </span>
                        <el-pagination style="padding: 30px 0px 0 0" background layout="prev, pager, next"
                            :total="total > 10000 ? 10000 : total" :page-sizes="[10, 20]" :page-size="cqu.size"
                            @size-change="handleSizeChange" :current-page.sync="cqu.page"
                            @current-change="handleCurrentChange"></el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :title="$t('chatdata.hint')" :visible.sync="centerDialogVisible" :width="'720px'" center
            class="steer__" :close-on-click-modal="false">
            <div class="answer_css_">
                <p style="color: #000000;line-height: 30px;font-weight: 600;font-size: 18px;">
                    ChatFellows
                </p>
                <p style="font-size: 18px; margin: 10px 0 30px 0; line-height: 20px">
                    {{ organ_name }}{{ $t('chatfellows.introduceOne') }}
                </p>
                <p class="p_tit">{{ $t('chatfellows.introduceTwo') }}</p>
                <p class="p_txt" style="text-indent: 2em;">
                    {{ $t('chatfellows.introduceThree_one') }}{{ organ_name }}
                    {{ $t('chatfellows.introduceThree_two') }}
                    {{ organ_name }}
                    {{ $t('chatfellows.introduceThree') }}
                </p>
                <p class="p_txt" style="text-indent: 2em;">
                    {{ $t('chatfellows.introduceThree_one') }}
                    {{ organ_name }}
                    {{ $t('chatfellows.introduceFour') }}
                </p>
                <p class="p_tit">{{ $t('chatfellows.introduceFive') }}</p>
                <p class="p_txt">
                    {{ $t('chatfellows.introduceSix') }}
                </p>
                <p class="p_txt">
                    {{ $t('chatfellows.introduceSeven') }}
                </p>
                <p class="p_txt">
                    {{ $t('chatfellows.introduceTen') }}
                </p>
                <p class="p_txt">
                    {{ $t('chatfellows.introduceEight') }}
                </p>
                <p class="p_txt">
                    {{ $t('chatfellows.introduceNine') }}
                </p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button style="letter-spacing: 3px; font-weight: 600" size="small" type="primary"
                    @click="close_click" round>{{ $t('chatfellows.knowBtn') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { chatCqu } from "@/api/classify";
import comHeader from '@/components/ComHeader.vue'
import store from "@/store";
export default {
    components: { comHeader },
    data() {
        return {
            textarea: "",
            Anti_shake: false,
            year_s: [],
            subject_s: [],
            author_s: [],
            cqu: {
                page: 1,
                size: 10,
                year: [],
                author: [],
                content: "",
                category: [],
            },
            list_data: [],
            total: 0,
            loading: false,
            centerDialogVisible: false,
            citation: "",
            sift_orr: true,
            centerDialogVisible: true,
            organ_name: "",
            centerDialogVisible_: false,
            role_: "",
            active: 4,
            value: 'ChatFellows'
        };
    },
    created() {
        if (store.getCookie("rolePermissions")) {
            this.role_ = store.getCookie("rolePermissions");
        }
        this.get_data();
        if (sessionStorage.getItem("steer_SCI")) {
            this.centerDialogVisible = true;
        } else {
            this.centerDialogVisible = false;
        }
        if (store.getCookie("organ_name")) {
            // let organ_arr = store.getCookie("organ_name").split("大学");
            this.organ_name = store.getCookie("organ_name")
        }
    },
    methods: {
        close_click() {
            this.centerDialogVisible = false;
            sessionStorage.removeItem("steer_SCI");
        },
        skip_routing(type) {
            // console.log(type);
            if (type == "ChatAnswer") {
                this.$router.push({ path: "/home" });
            } else if (type == "ChatResearch") {
                this.$router.push({ path: "/chatNewResearch" });
            } else {
                this.$router.push({ path: "/chatResearch" });
            }
        },
        sift_() {
            // console.log(this.cqu);
            if (this.sift_orr) {
                this.cqu.page = 1;
                this.get_data();
                this.sift_orr = false;
            }
        },
        sift_all() {
            // console.log(this.cqu);
            this.cqu.page = 1;
            this.get_data();
        },
        search_img(txt, chtxt) {
            if (txt !== '') {
                this.textarea = txt;
            } else {
                this.textarea = chtxt
            }

            this.search();
        },
        search() {
            this.cqu = {
                page: 1,
                size: 10,
                year: [],
                author: [],
                content: this.textarea,
                category: [],
            };
            this.get_data();
        },
        get_data() {
            this.loading = true;
            let cqu_copy = { ...this.cqu };
            // if (cqu_copy.year.length > 0) {
            //   cqu_copy.year = JSON.stringify(cqu_copy.year);
            // } else {
            //   cqu_copy.year = "";
            // }

            // if (cqu_copy.category.length > 0) {
            //   cqu_copy.category = JSON.stringify(cqu_copy.category);
            // } else {
            //   cqu_copy.category = "";
            // }
            // if (cqu_copy.author.length > 0) {
            //   cqu_copy.author = JSON.stringify(cqu_copy.author);
            // } else {
            //   cqu_copy.author = "";
            // }

            chatCqu(cqu_copy)
                .then((res) => {
                    if (res.data.code == 0) {
                        if (
                            this.year_s.length < res.data.data.category.year.buckets.length
                        ) {
                            this.year_s = res.data.data.category.year.buckets;
                        }
                        if (
                            this.subject_s.length <
                            res.data.data.category.subject.buckets.length
                        ) {
                            this.subject_s = res.data.data.category.subject.buckets;
                        }
                        if (
                            this.author_s.length <
                            res.data.data.category.author.buckets.length
                        ) {
                            this.author_s = res.data.data.category.author.buckets;
                        }
                        res.data.data.list.forEach((item, index) => {
                            item._source.abstract_show = false;
                            item._source.abstract_show_ch = false;
                        });
                        this.list_data = res.data.data.list;

                        this.total = res.data.data.total;
                        this.loading = false;
                        this.sift_orr = true;
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.sift_orr = true;
                    // console.log(err); //直接捕获 new Promise  reject("rejected status")
                });
        },
        show_all(i) {
            this.list_data[i]._source.abstract_show =
                !this.list_data[i]._source.abstract_show;
        },
        show_all_ch(i) {
            this.list_data[i]._source.abstract_show_ch =
                !this.list_data[i]._source.abstract_show_ch;
        },
        handleSizeChange(val) {
            this.cqu.size = val;
            this.get_data();
        },
        handleCurrentChange(val) {
            this.cqu.page = val;
            this.get_data();
        },
        cite_pick(data) {
            // console.log(data);
            this.citation = "";
            // return;
            let quotation = "[1]";
            // {{ $t('public.author') }}
            for (let i = 0; i < data._source.author.length; i++) {
                // console.log(quotation);
                quotation += data._source.author[i];
                if (i + 1 < data._source.author.length) {
                    quotation += ",";
                }
            }

            // 文献标题
            quotation += "." + data._source.title + "[J]";
            this.citation = quotation + ".";
            this.centerDialogVisible = true;
        },

        doi_url(url) {
            window.open("https://doi.org/" + url, "_blank");
        },
    },
};
</script>

<style lang='less' scoped>
.ChatCQU_sci {
    height: 100vh;
    position: relative;
    //   padding: 20px 0;
    // background-image: url("../../assets/img/背景图/小助手-05(1).jpg");
    background-size: cover;
    background-position: center center;
}

.ChatCQU_sci {
    // padding: 20px 0 0 0 ;
    // // width: 100%; height: 100vh;
    // background: url("../../assets/img/背景图/小助手-05(1).jpg")  no-repeat;
    // background-size: 100% 100%;
    // background-attachment: fixed;
}

.box {
    margin: auto;
    width: 80%;
    max-width: 1500px;

    .chat_s {
        // text-align: center;
        // text-align: left;
        // line-height: 50px;
        // position: relative;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        flex-wrap: wrap;
        // flex-shrink: 0;
        margin: 10px 0 10px 0;

        .skip_host {
            display: inline-block;
            padding: 10px 30px 10px 30px;
            color: #444547;
            font-weight: 600;
            font-size: 20px;
        }

        .skip_sub {
            display: inline-block;
            //   width: 180px;
            padding: 10px 20px 10px 20px;
            font-size: 15px;
            font-weight: 500;
            letter-spacing: 0px;
            color: #909399;
            // line-height: 20px;
        }

        .skip_sub:hover {
            cursor: pointer;
            color: #444547;
            font-weight: 600;
        }
    }
}

.main_body {
    // padding: 20px;
    margin: 20px;
    margin-top: 0;
    display: flex;
    justify-content: space-between;

    // height: calc(100vh - 150px);
    // height: 420px;
    .main_left::-webkit-scrollbar {
        display: none;
    }

    .main_left {
        width: 33%;
        // margin: 0 10px 0 0;
        background: white;
        border-radius: 10px;
        padding: 10px;
        height: calc(100vh - 100px);
        overflow-x: hidden;
        overflow-y: scroll;
    }

    .main_right {
        width: 66%;
        // margin: 0 0px 0 10px;
        background: white;
        border-radius: 10px;
    }
}

.main_left {
    h2 {
        text-align: left;
        line-height: 35px;
        color: #444547;
        font-weight: 800;
        font-size: 16px;
        letter-spacing: 1px;
    }
}

.submit_css {
    width: 100%;
    margin: 10px 0;

    /deep/ span {
        font-weight: 600;
        letter-spacing: 10px;
        font-size: 16px;
    }
}

.sift_s::-webkit-scrollbar {
    // display: none;
}

.sift_s {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    // height: 420px;
    // overflow-x: hidden;
    // overflow-y: scroll;
    .sift_box {
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        border-radius: 10px;
        margin: 10px 0;
        width: 49%;

        // height: 30%;
        h3 {
            background-color: #e6a23c;
            text-align: left;
            letter-spacing: 3px;
            line-height: 30px;
            font-weight: 600;
            color: white;
            padding: 0 10px;
            border-start-start-radius: 10px;
            border-start-end-radius: 10px;
            cursor: pointer;
        }

        .sift_tit {
            background-color: #e6a23c;
            text-align: left;
            letter-spacing: 3px;

            color: white;
            padding: 0 10px;
            border-start-start-radius: 10px;
            border-start-end-radius: 10px;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .tit {
                font-weight: 600;
                line-height: 40px;
                font-size: 16px;
            }

            .sub {
                padding: 5px 10px 5px 12px;
                font-size: 10px;
                border: 1px solid #ffffff;
                border-radius: 15px;
                display: inline-block;
            }

            .sub:hover {
                background: #fdf6ec;
                border: 1px solid #f5dab1;
                color: #e6a23c;
            }
        }

        .sift_list::-webkit-scrollbar {
            // display: none;
            width: 5px;
        }

        .sift_list::-webkit-scrollbar-thumb {
            border-radius: 10px;
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            background: rgba(0, 0, 0, 0.2);
        }

        .sift_list::-webkit-scrollbar-track {
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            border-radius: 0;
            background: rgba(190, 235, 231, 0.1);
        }

        .sift_list:hover {
            overflow: auto;
        }

        .sift_list {
            height: 200px;
            // min-height: 200px;
            // max-height: 240px;
            width: 100%;
            overflow-x: hidden;
            overflow-y: hidden;
            border-end-start-radius: 10px;
            border-end-end-radius: 10px;

            .el-checkbox {
                display: flex;
                align-content: center;
                margin: 10px;

                /deep/ .el-checkbox__input {
                    white-space: nowrap;
                    cursor: pointer;
                    outline: none;
                    display: inline-block;
                    line-height: 1;
                    position: relative;
                    vertical-align: middle;
                }

                /deep/ .el-checkbox__inner {
                    display: inline-block;
                    position: relative;
                    top: 2px;
                }

                /deep/ .el-checkbox__original {
                    opacity: 0;
                    outline: 0;
                    position: absolute !important;
                    margin: 0;
                    width: 0 !important;
                    height: 0 !important;
                    z-index: -1;
                }

                /deep/ .el-checkbox__label {
                    white-space: nowrap; //文本强制不换行；
                    text-overflow: ellipsis; //文本溢出显示省略号；
                    overflow: hidden; //溢出的部分隐藏；
                }
            }
        }
    }
}

.main_right {
    text-align: left;

    .data_list {
        overflow: hidden;
        padding: 10px;
        margin-top: 5px;
    }

    .data_list:hover::-webkit-scrollbar-thumb {
        border-radius: 10px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(0, 0, 0, 0.2);
    }

    .data_list:hover::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 0;
        background: rgba(190, 235, 231, 0.1);
    }

    .data_list::-webkit-scrollbar {
        // display: none;\
        width: 5px;
    }

    .data_list::-webkit-scrollbar-thumb {
        border-radius: 10px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
        background: rgba(0, 0, 0, 0);
    }

    .data_list::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
        border-radius: 0;
        background: rgba(190, 235, 231, 0);
    }

    .data_list {
        max-height: calc(100vh - 200px);
        overflow-x: hidden;
        overflow-y: auto;

        .data_txt {
            margin: 0 0 10px 0;

            border: 1px rgb(117, 117, 117) solid;
            border-radius: 5px;
            padding: 10px;

            .txt_top {
                display: flex;
                align-items: center;
                justify-content: space-between;

                .txt_s {
                    width: calc(100% - 120px);

                    h3 {
                        font-size: 16px;
                        letter-spacing: 1px;
                        line-height: 22px;
                        margin: 0 0 5px 0;
                        color: #000000;
                        font-weight: 600;
                    }

                    p {
                        line-height: 20px;
                        margin: 0 0 10px 0;
                        color: #5a5a5a;
                    }
                }

                .img_s {
                    width: 95px;
                    cursor: pointer;

                    img {
                        // width: 80px;
                        width: 55px;
                        margin: 0 20px;
                    }
                }
            }

            .abstract_css {
                line-height: 25px;
            }
        }
    }

    .pag_s::-webkit-scrollbar {
        display: none;
    }

    .pag_s {
        display: flex;
        justify-content: center;
        width: 100%;
        overflow-x: scroll;
        overflow-y: hidden;

    }

    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
        background: #e6a23c;
    }
}

.view_all {
    margin: 0 0 0 10px;
    font-weight: 600;
    cursor: pointer;
}

.view_all:hover {
    color: #409eff;
}

.img_txt {
    color: #a21e1e;
    font-size: 15px;
    // letter-spacing: 5px;
    font-weight: 600;
    text-align: center;
    line-height: 25px;
}

.list_bottom {
    // margin: 10px 0;

    line-height: 30px;
    cursor: pointer;
}

.fraction_ {
    display: inline-block;
    color: #8b1a1a;
    font-weight: 600;
    font-size: 20px;
}

.cite {
    display: inline-block;
    display: inline-block;
    line-height: 30px;
    position: relative;
    top: -2px;
    cursor: pointer;
}

.tooltip_span {
    display: inline-block;
    width: 100%;
    white-space: nowrap; //文本强制不换行；
    text-overflow: ellipsis; //文本溢出显示省略号；
    overflow: hidden; //溢出的部分隐藏；
}

.copy {
    display: flex;
    justify-content: center;
    align-items: center;

    .copy_input {
        min-width: 60%;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        background-color: #f5f7fa;
        border-color: #e4e7ed;
        color: #c0c4cc;
        min-height: 40px;
        line-height: 40px;
        outline: none;
        padding: 0 15px;
    }

    .el-icon-document-copy {
        margin: 0 0 0 10px;
        font-size: 20px;
    }

    .el-icon-document-copy:hover {
        cursor: pointer;
        color: #409eff;
    }
}

.slogan_ {
    margin: 0 20px;
    color: #444547;
    font-weight: 600;
    font-size: 15px;
}

.steer__ {
    p {
        line-height: 25px;
        color: #000000;
    }

    /deep/ .el-dialog {
        border-radius: 20px;
        // position: relative;
        // left: 110px;
    }

    /deep/ .el-dialog__header {
        display: none;
    }

    /deep/ .el-dialog__body {
        padding: 30px 25px 0 30px;
    }

    .p_tit {
        font-weight: 600;
    }

    .p_txt {
        line-height: 22px;
        margin: 10px 0;
    }
}

.doi_css {
    color: #007398;
    border-bottom: 1px solid #ffffff;
    cursor: pointer;
}

.doi_css:hover {
    color: #409eff;
    border-bottom: 1px solid #409eff;
}

.answer_css_ {
    max-height: 540px;
    overflow: auto;
    word-break: normal;
    text-align: justify;
    line-height: 20px;
    padding: 0 8px;
}

.answer_css_::-webkit-scrollbar {
    // display: none;\
    margin-left: 5px;
    width: 5px;
}

.answer_css_::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
    background: rgba(0, 0, 0, 0);
}

.answer_css_::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
    border-radius: 0;
    background: rgba(190, 235, 231, 0);
}

.answer_css_:hover::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
}

.answer_css_:hover::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(190, 235, 231, 0.1);
}
</style>